<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Face ID lock 1">
      <g id="Group">
        <path
          id="Vector"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8657 27.4336H9.18969C6.87902 27.4336 4.99902 25.5562 4.99902 23.2469V21.1549C4.99902 20.6029 4.55102 20.1549 3.99902 20.1549C3.44702 20.1549 2.99902 20.6029 2.99902 21.1549V23.2469C2.99902 26.6589 5.77636 29.4336 9.18969 29.4336H10.8657C11.4177 29.4336 11.8657 28.9856 11.8657 28.4336C11.8657 27.8816 11.4177 27.4336 10.8657 27.4336Z"
          fill="#8F42FF" />
        <path
          id="Vector_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.0021 20.1549C27.4501 20.1549 27.0021 20.6029 27.0021 21.1549V23.2469C27.0021 25.5562 25.1221 27.4336 22.8114 27.4336H21.0928C20.5408 27.4336 20.0928 27.8816 20.0928 28.4336C20.0928 28.9856 20.5408 29.4336 21.0928 29.4336H22.8114C26.2248 29.4336 29.0021 26.6589 29.0021 23.2469V21.1549C29.0021 20.6029 28.5541 20.1549 28.0021 20.1549Z"
          fill="#8F42FF" />
        <path
          id="Vector_3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99902 12.7269C4.55102 12.7269 4.99902 12.2789 4.99902 11.7269V9.63358C4.99902 7.31625 6.87902 5.43225 9.18969 5.43225H10.9084C11.4604 5.43225 11.9084 4.98425 11.9084 4.43225C11.9084 3.88025 11.4604 3.43225 10.9084 3.43225H9.18969C5.77636 3.43225 2.99902 6.21358 2.99902 9.63358V11.7269C2.99902 12.2789 3.44702 12.7269 3.99902 12.7269Z"
          fill="#8F42FF" />
        <path
          id="Vector_4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.8108 3.43359H21.1348C20.5828 3.43359 20.1348 3.88159 20.1348 4.43359C20.1348 4.98559 20.5828 5.43359 21.1348 5.43359H22.8108C25.1214 5.43359 27.0014 7.31759 27.0014 9.63359V11.7283C27.0014 12.2803 27.4494 12.7283 28.0014 12.7283C28.5534 12.7283 29.0014 12.2803 29.0014 11.7283V9.63359C29.0014 6.21493 26.2241 3.43359 22.8108 3.43359Z"
          fill="#8F42FF" />
      </g>
      <path
        id="Vector_5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9731 11.4219H15.9891C17.0225 11.4219 17.8705 12.2565 17.8838 13.2765V13.9552H14.1185V13.2792C14.1371 12.2552 14.9545 11.4405 15.9731 11.4219ZM21.8105 20.0619V17.3419C21.8105 16.0019 21.0198 14.8512 19.8838 14.3019V13.2632C19.8571 11.1379 18.1118 9.42188 15.9798 9.42188H15.9465C13.8358 9.45921 12.1558 11.1379 12.1184 13.2619V14.3019C10.9824 14.8499 10.1904 16.0019 10.1904 17.3419V20.0619C10.1904 21.9299 11.7144 23.4499 13.5865 23.4499H18.4158C20.2878 23.4499 21.8105 21.9299 21.8105 20.0619Z"
        fill="#BCAFFE" />
    </g>
  </svg>
</template>
